// Trigger app build to refresh prod static assets (index.html / chunk sync).
import React from 'react';
import { createRoot } from 'react-dom/client';
// import { Amplify } from 'aws-amplify';
// import config from './aws-exports';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.min.css';
import 'react-toastify/dist/ReactToastify.css';
// Import eptai-app-components design system (fonts, tokens, base styles)
import '@eptai/eptai-app-components/styles';
import App from './App';

// Amplify.configure(config);

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container); // Create a root with React 18

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
